import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  Typography,
  TableRow,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  ExpansionPanelActions
} from "@material-ui/core";
import DescriptiveRow from "../components/DescriptiveRow.jsx";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import { RemoveField } from "helpers/ReduxHelpers";
import _, { toInteger } from "lodash";
import React from "react";
import { change, Field } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading.jsx";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import { required, percentage } from "helpers/ValidationHelpers";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import DescriptiveCell from "../components/DescriptiveCell.jsx";
import 
      {
        fnaResult, 
        cgtAsset, 
        incomeNeedAtDeath, 
        incomeProvisionAtDeath, 
        assetsDisabilityCgt, 
        disabilityIncomeNeed, 
        disabilityIncomeProvision
      } from "./objects/FNA_result_vars.js"
import assumptions from "./objects/assumptions.js"
import { inspect } from 'util' // or directly

const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value
  };
};

const CustomField = props => (
  <TableCell className="cellPaddingSmall">
    <FormControl fullWidth>
      <Field {...props} />
    </FormControl>
  </TableCell>
);

const CustomField2 = props => (
  <FormControl fullWidth style={{ bottom: "10px" }}>
    <Field {...props} />
  </FormControl>
);

const grandSeperator = val => {
  if(!val) {
		return "0.00"
	}
  
  val = val
    .toString()
    .replace(/,/g, "")
    .replace(/ /g, "");
  let parsed = parseFloat(val);

  if (!isNaN(parsed)) {
    return parsed.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).replace(/,/g, " ");
  } else {
    return val;
  }
};



class OtherIncome extends React.Component {

  mustBeFullPercentage = (value, a, b, c) =>
  {

    var iInit = c.split(".")
    var iLength = iInit.length -1;
    var i = iInit[iLength].replace("spouse", "").replace("charity", "").replace("dependents", "").replace("trust", "").replace("charity", "").replace("other", "")

    var cat = this.props.state[iInit[0]][i]
    if(iInit.length > 2)
      cat = this.props.state[iInit[0]][[iInit[1]]][i]

    var fullPercentage = parseInt(cat.estateInherit) + parseInt(cat.spouseInherit) + parseInt(cat.dependentsInherit) + parseInt(cat.trustInherit) +  parseInt(cat.charityInherit) + parseInt(cat.otherInherit);
  
    //console.log("Testing persentage " + i + " " + cat + " " + fullPercentage)
    if(fullPercentage != 100 || parseInt(cat.estateInherit) < 0)
      return "Must add up to 100";
  
    return undefined;
  }

  componentDidMount() {
    this.props.scrollMeBar();
    var expand = this.props.state.deathDistribution;
    expand.expanded.fixedAssests = false;
    expand.expanded.liquidAssets = false;
    expand.expanded.policies = false;
    expand.expanded.bequests = false;
    expand.expanded.retirement = false;
    this.props.update();
  }

  componentDidUpdate()
  {
    // Initializing dynamic fields. See initializeDynamicField decleration for structure.
     var fieldsAssets = 
     [
      {
        field: "assets",      
        fieldName: "assets.estate",  
        fieldVar: "estateInherit",   
        value: "100"
      },
      {
        field: "assets",      
        fieldName: "assets.spouse",  
        fieldVar: "spouseInherit",   
        value: "0"
      },
      {
        field: "assets",      
        fieldName: "assets.dependents",  
        fieldVar: "dependentsInherit",   
        value: "0"
      },
      {
        field: "assets",      
        fieldName: "assets.trust",  
        fieldVar: "trustInherit",   
        value: "0"
      },
      {
        field: "assets",      
        fieldName: "assets.other",  
        fieldVar: "otherInherit",   
        value: "0"
      },
      {
        field: "assets",      
        fieldName: "assets.charity",  
        fieldVar: "charityInherit",   
        value: "0"
      },

      
     ]

     var fieldsPolicies = 
     [
      {
        field: "policy",      
        fieldName: "policy.estate",  
        fieldVar: "estateInherit",   
        value: "100"
      },
      {
        field: "policy",      
        fieldName: "policy.spouse",  
        fieldVar: "spouseInherit",   
        value: "0"
      },
      {
        field: "policy",      
        fieldName: "policy.dependents",  
        fieldVar: "dependentsInherit",   
        value: "0"
      },
      {
        field: "policy",      
        fieldName: "policy.trust",  
        fieldVar: "trustInherit",   
        value: "0"
      },
      {
        field: "policy",      
        fieldName: "policy.other",  
        fieldVar: "otherInherit",   
        value: "0"
      },
      {
        field: "policy",      
        fieldName: "policy.charity",  
        fieldVar: "charityInherit",   
        value: "0"
      }
     ]

     var fieldsCashBequests = 
     [
      {
        field: "needs.cashBequests",      
        fieldName: "needs.cashBequests.estate",  
        fieldVar: "estateInherit",   
        value: "0",
        conditions:
        [
          {
            condition: "category", 
            param: "cashBequestCharity" ,    
            falseValue: "100"
          }
        ]
      },
      {
        field: "needs.cashBequests",      
        fieldName: "needs.cashBequests.spouse",  
        fieldVar: "spouseInherit",   
        value: "0"
      },
      {
        field: "needs.cashBequests",      
        fieldName: "needs.cashBequests.dependents",  
        fieldVar: "dependentsInherit",   
        value: "0"
      },
      {
        field: "needs.cashBequests",      
        fieldName: "needs.cashBequests.trust",  
        fieldVar: "trustInherit",   
        value: "0"
      },
      {
        field: "needs.cashBequests",      
        fieldName: "needs.cashBequests.other",  
        fieldVar: "otherInherit",   
        value: "0"
      },
      {
        field: "needs.cashBequests",      
        fieldName: "needs.cashBequests.charity",  
        fieldVar: "charityInherit",   
        value: "100",
        conditions:
        [
          {
            condition: "category", 
            param: "cashBequestCharity" ,    
            falseValue: "0"
          }
        ]
      }
     ]

     var fieldsRetirement = 
     [
      {
        field: "retirement",      
        fieldName: "retirement.estate",  
        fieldVar: "estateInherit",   
        value: "100"
      },
      {
        field: "retirement",      
        fieldName: "retirement.spouse",  
        fieldVar: "spouseInherit",   
        value: "0"
      },
      {
        field: "retirement",      
        fieldName: "retirement.dependents",  
        fieldVar: "dependentsInherit",   
        value: "0"
      },
      {
        field: "retirement",      
        fieldName: "retirement.trust",  
        fieldVar: "trustInherit",   
        value: "0"
      },
      {
        field: "retirement",      
        fieldName: "retirement.other",  
        fieldVar: "otherInherit",   
        value: "0"
      },
      {
        field: "retirement",      
        fieldName: "retirement.charity",  
        fieldVar: "charityInherit",   
        value: "0"
      },

      
     ]



    this.props.initializeDynamicField("assetsDeathInit", fieldsAssets);
    this.props.initializeDynamicField("policiesDeathInit", fieldsPolicies);
    this.props.initializeDynamicField("cashDeathInit", fieldsCashBequests);
    this.props.initializeDynamicField("retirementDeathInit", fieldsRetirement);
    
  }



  checkItem = (label, name, changeFunc) => {
    return (
      
              <FormControl style={{marginBottom: "-30px", paddingBottom: "-30px", left:"30px"}}>
                <Field
                  component={FormCheckbox}
                  name={name}
                  onChange={(e, f, g, h) => {
                    changeFunc(f, h)

                  }}

                />
              </FormControl>
           
    );
  };

  changeDutyExcempt= (value, name) => 
  {
    var policies = this.props.state.policy;
    var policy = name.replace("dutyExcempt", "")
    policies[policy].dutyExcempt = value
    //this.props.changePolicy(policy);
  }

  fixedAssestsExpand = (expand) => {
    var asset = this.props.state.deathDistribution;
    asset.expanded.fixedAssests = !asset.expanded.fixedAssests;
    this.props.deathDistExpand(asset);
  }

  liquidAssestsExpand = (expand) => {
    var asset = this.props.state.deathDistribution;
    asset.expanded.liquidAssets = !asset.expanded.liquidAssets;
    this.props.deathDistExpand(asset);
  }

  policiesExpand = (expand) => {
    var asset = this.props.state.deathDistribution;
    asset.expanded.policies = !asset.expanded.policies;
    this.props.deathDistExpand(asset);
  }

  bequestsExpand = (expand) => {
    var asset = this.props.state.deathDistribution;
    asset.expanded.bequests = !asset.expanded.bequests;
    this.props.deathDistExpand(asset);
  }

  retirementExpand = (expand) => {
    var asset = this.props.state.deathDistribution;
    asset.expanded.retirement = !asset.expanded.retirement;
    this.props.deathDistExpand(asset);
  }


  

  changeCharity = (value, name) => {

    
    var cat = name.split(".")[0]
    var changeObj = this.props.state[cat];
    var i = name.split(".")[1].replace("charity", "")

    if(name.split(".").length > 2)
    {
      cat += "." + name.split(".")[1]
      changeObj = changeObj[name.split(".")[1]];
      i = name.split(".")[2].replace("charity", "")
    }
    changeObj[i].charityInherit = value

    
    this.props.changeDeathDist(cat, changeObj);
    this.calcEstateInherit(cat, i)

    this.getInheretValue(cat, "charityInherit")
  }
 
  calcEstateInherit(cat, i)
  {
    
    var cat1= cat.split('.')
    if(cat1.length > 1)
      this.props.state[cat1[0]][cat1[1]][i].estateInherit = 100  - this.props.state[cat1[0]][cat1[1]][i].spouseInherit 
                                                  - this.props.state[cat1[0]][cat1[1]][i].dependentsInherit 
                                                  - this.props.state[cat1[0]][cat1[1]][i].trustInherit 
                                                  - this.props.state[cat1[0]][cat1[1]][i].charityInherit 
                                                  - this.props.state[cat1[0]][cat1[1]][i].otherInherit
    else
    {
      this.props.state[cat][i].estateInherit = 100  - this.props.state[cat][i].spouseInherit 
                                                  - this.props.state[cat][i].dependentsInherit 
                                                  - this.props.state[cat][i].trustInherit 
                                                  - this.props.state[cat][i].charityInherit 
                                                  - this.props.state[cat][i].otherInherit
    }
  }


  changeEstate = (value, name) => {

    
    var cat = name.split(".")[0]
    var changeObj = this.props.state[cat];
    var i = name.split(".")[1].replace("estate", "")

    if(name.split(".").length > 2)
    {
      cat += "." + name.split(".")[1]
      changeObj = changeObj[name.split(".")[1]];
      i = name.split(".")[2].replace("estate", "")
    }
    
    
    changeObj[i].estateInherit = value
    this.props.changeDeathDist(cat, changeObj);

    this.getInheretValue(cat, "estateInherit")
  }

  changeSpouse = (value, name) => {
    var cat = name.split(".")[0]
    var changeObj = this.props.state[cat];
    var i = name.split(".")[1].replace("spouse", "")

    if(name.split(".").length > 2)
    {
      cat += "." + name.split(".")[1]
      changeObj = changeObj[name.split(".")[1]];
      i = name.split(".")[2].replace("spouse", "")
    }
    
    changeObj[i].spouseInherit = value
    this.props.changeDeathDist(cat, changeObj);
    
    this.calcEstateInherit(cat, i)

    
  }

  changeDependents = (value, name) => {
    var cat = name.split(".")[0]
    var changeObj = this.props.state[cat];
    var i = name.split(".")[1].replace("dependents", "")

    if(name.split(".").length > 2)
    {
      cat += "." + name.split(".")[1]
      changeObj = changeObj[name.split(".")[1]];
      i = name.split(".")[2].replace("dependents", "")
    }
    //console.log("->>>>>>>>>>>>>>>>>>> " + cat + " " + changeObj + " " + i)
    changeObj[i].dependentsInherit = value
    this.props.changeDeathDist(cat, changeObj);
    this.calcEstateInherit(cat, i)

  }

  changeTrust = (value, name) => {
    var cat = name.split(".")[0]
    var changeObj = this.props.state[cat];
    var i = name.split(".")[1].replace("trust", "")

    if(name.split(".").length > 2)
    {
      cat += "." + name.split(".")[1]
      changeObj = changeObj[name.split(".")[1]];
      i = name.split(".")[2].replace("trust", "")
    }
    
    changeObj[i].trustInherit = value
    this.props.changeDeathDist(cat, changeObj);
    this.calcEstateInherit(cat, i)

  }

  changeOther = (value, name) => {
    var cat = name.split(".")[0]
    var changeObj = this.props.state[cat];
    var i = name.split(".")[1].replace("other", "")

    if(name.split(".").length > 2)
    {
      cat += "." + name.split(".")[1]
      changeObj = changeObj[name.split(".")[1]];
      i = name.split(".")[2].replace("other", "")
    }
    
    changeObj[i].otherInherit = value
    this.props.changeDeathDist(cat, changeObj);
    this.calcEstateInherit(cat, i)

  }

  getAssetValue = (i) =>
  {
    this.calcBalanceSheet()
    return ((this.props.state.assets[i].marketValue)*this.props.state.assets[i].ownershipClient/100)
  }

  
  getAssetTotalValue = (l) =>
  {
    var total = 0.00;
    if(!l)
    this.props.state.assets.map((e, i) =>
      {
        if(!e.liquid)
        total += this.getAssetValue(i)
      }
    )
    else
    this.props.state.assets.map((e, i) =>
      {
        if(e.liquid)
        total += this.getAssetValue(i)
      }
    )

    this.props.state.policy.map((e,i) =>
    {
      if(e.party == "client" && e.LifeAssured != "client")
        total += parseFloat(e.cashValue)
    })

    if(!l)
      this.props.state.deathDistribution.totals.fixedAssests = total
      else
      this.props.state.deathDistribution.totals.liquidAssets = total

      this.calcBalanceSheet()
    return grandSeperator(total);
  }

  getPolicyTotalValue = () =>
  {
    var total = 0.00
    this.props.state.policy.map((e,i) =>
    {
      if(e.LifeAssured == "client")
        total += parseFloat(e.death)
    })
    this.calcBalanceSheet()
    return grandSeperator(total)
  }

  getRetirementTotalValue = () =>
  {
    var total = 0.00
    this.props.state.retirement.map((e,i) =>
    {
     
      total += parseFloat(e.value)
    })
    this.calcBalanceSheet()
    return grandSeperator(total)
  }

  getBequestsTotalValue = () =>
  {
    var total = 0.00
    this.props.state.needs.cashBequests.map((e,i) =>
    {
      if(e.category == "cashBequest" || e.category == "cashBequestCharity")
        total += parseFloat(e.mounthlyAmount);
    })
    this.calcBalanceSheet()
    return grandSeperator(total)
  }
  
  getInheretValue = (cat, inhereter) =>
  {
    var total = 0.00;
    if(cat == "assets")
      this.props.state[cat].map((e, i) =>
      {
          if(!e.liquid)
          total += (e.marketValue*e.ownershipClient/100 ) * e[inhereter]/100
        
      })

      if(cat == "assetsL")
      {
        cat = "assets"
        this.props.state[cat].map((e, i) =>
        {
            if(e.liquid)
            total += (e.marketValue*e.ownershipClient/100 ) * e[inhereter]/100
          
        })
        this.props.state.policy.map((e,i) =>
        {
          if(e.party == "client" && e.LifeAssured != "client")
            total += parseFloat(e.cashValue * e[inhereter]/100)
        })
      }

      if(cat == "policy")
      this.props.state[cat].map((e, i) =>
      {
          if(e.LifeAssured == "client")
          if(e[inhereter])
            total +=  parseFloat(e.death)* e[inhereter]/100
        
      })

      if(cat == "retirement")
      this.props.state[cat].map((e, i) =>
      {
          if(e[inhereter])
          total +=  parseFloat(e.value)* e[inhereter]/100
        
      })
      if(cat == "needs.cashBequests")
      {
        var cat1 = cat.split(".")[0]
        var cat2 = cat.split(".")[1]
        this.props.state[cat1][cat2].map((e, i) =>
        {
            if(e.category == "cashBequest" || e.category == "cashBequestCharity")
              if(e[inhereter])
                total +=  parseFloat(e.mounthlyAmount)* e[inhereter]/100
          
        })
      }
      
      this.calcBalanceSheet()
      //console.log(this.props.state)
      return grandSeperator(total)
  }

  convertAsset = (e) =>
  {
    var assets = this.props.state.assets;
    var i = e.currentTarget.name.replace("convert", '')

    assets[i].liquid = !assets[i].liquid;
    this.calcBalanceSheet()
    this.props.update();
  }

  
  

  calcBalanceSheet = () =>
  {
   
    this.props.state.result = new fnaResult().fna
    this.props.state.assets.map((e, i) => 
    {
      
      var balanceSheetAsset = {};
      balanceSheetAsset.description = e.description;
      balanceSheetAsset.ownershipClient = e.ownershipClient/100 * e.marketValue;
      balanceSheetAsset.ownershipSpouse = e.ownershipSpouse/100 * e.marketValue;
      this.props.state.result.balanceSheet.netAssetsClient += balanceSheetAsset.ownershipClient;
      this.props.state.result.balanceSheet.netAssetsSpouse += balanceSheetAsset.ownershipSpouse

      this.props.state.result.balanceSheet.assets.push(balanceSheetAsset);

      if(e.liability > 0)
      {
        var balanceSheetLiability = {};
        if(e.ownershipClient > 0)
        {
          
          balanceSheetLiability.description = e.description;
          balanceSheetLiability.amountClient = parseFloat(e.liability) * e.ownershipClient/100;

          this.props.state.result.balanceSheet.netLiabilitiesClient += parseFloat(balanceSheetLiability.amountClient);
          
        }

        if(e.ownershipSpouse > 0)
        {
          balanceSheetLiability.description = e.description;
          balanceSheetLiability.amountSpouse = parseFloat(e.liability) * e.ownershipSpouse/100;

          this.props.state.result.balanceSheet.netLiabilitiesSpouse += parseFloat(balanceSheetLiability.amountSpouse);
          
        }
        this.props.state.result.balanceSheet.liabilities.push(balanceSheetLiability);
        
      }
    })

    this.props.state.liabilities.map((e, i) => 
    {
      var balanceSheetLiability = {};
      balanceSheetLiability.description = e.description;
      if(e.party == "client")
      {
        balanceSheetLiability.amountClient = parseFloat(e.amount);
        this.props.state.result.balanceSheet.netLiabilitiesClient += parseFloat(e.amount);
      }
      else
      {
        balanceSheetLiability.amountSpouse = parseFloat(e.amount);
        this.props.state.result.balanceSheet.netLiabilitiesSpouse += parseFloat(e.amount);
      }
        
      this.props.state.result.balanceSheet.liabilities.push(balanceSheetLiability);
    })

    var pToEstate = 0.00
    this.props.state.policy.map((e, i) => 
    {
      
      var balanceSheetPolicy = {};
        balanceSheetPolicy.description = e.description;
        if(e.LifeAssured == "client" )
      {
        pToEstate += parseFloat(e.death)* parseFloat(e.estateInherit)/100
      }
      if(e.party == "client" && e.LifeAssured != "client")
      {
          balanceSheetPolicy.amountClient = parseFloat(e.cashValue);
          this.props.state.result.balanceSheet.netPoliciesClient += parseFloat(e.cashValue);
          this.props.state.result.balanceSheet.policies.push(balanceSheetPolicy);
      }
      if(e.party == "spouse" && e.LifeAssured != "spouse" && e.LifeAssured != "client")
        {
          balanceSheetPolicy.amountSpouse = parseFloat(e.cashValue);
          this.props.state.result.balanceSheet.netPoliciesSpouse += parseFloat(e.cashValue);
          this.props.state.result.balanceSheet.policies.push(balanceSheetPolicy);
        }
          
       
      
    })

    this.props.state.result.balanceSheet.netTotalAssetsClient = parseFloat(this.props.state.result.balanceSheet.netAssetsClient) + parseFloat(this.props.state.result.balanceSheet.netPoliciesClient)  - parseFloat(this.props.state.result.balanceSheet.netLiabilitiesClient);
    this.props.state.result.balanceSheet.netTotalAssetsSpouse = parseFloat(this.props.state.result.balanceSheet.netAssetsSpouse) + parseFloat(this.props.state.result.balanceSheet.netPoliciesSpouse) - parseFloat(this.props.state.result.balanceSheet.netLiabilitiesSpouse);

    this.props.state.result.executorFees.percentageApplicable = this.props.state.execFee;
    this.props.state.result.executorFees.vat = this.props.state.vat;

    
    this.props.state.result.executorFees.pToEstate = pToEstate;
    this.props.state.result.executorFees.executorFee = (parseFloat(this.props.state.result.balanceSheet.netAssetsClient) + pToEstate) * 
                                                        parseFloat(this.props.state.execFee)/100 
    if(this.props.state.execTax) 
      this.props.state.result.executorFees.executorFee = this.props.state.result.executorFees.executorFee * (1 + parseFloat(this.props.state.vat)/100)
                                                        
                                                         //Need to add Policies to Estate

    this.calcCgt();
  }


  calcCgt = () =>
  {
    this.props.state.result.cgt.minuspResidence.primaryResidenceExclusion = assumptions.primary_residence_exemption;
    this.props.state.assets.map((e, i) => 
    {
      if(e.cgtPayable)
      {
        var temp = {};
        temp.description = e.description;
        temp.category = e.category
        temp.marketValue = parseFloat(e.marketValue) * parseFloat(e.ownershipClient)/100;
        temp.baseCost = parseFloat(e.baseCost)* parseFloat(e.ownershipClient)/100;
        temp.capitalGain = parseFloat(temp.marketValue) - parseFloat(temp.baseCost) //-e.liability;

        if(e.category == "farms_owned" && this.props.state.percentageOnFarm)
        {
          temp.marketValue *= 0.7
          temp.baseCost *= 0.7
          temp.capitalGain = parseFloat(temp.marketValue) - parseFloat(temp.baseCost)
        }
          

        if(e.category == "primary_residential")
        {
          if(temp.capitalGain - parseFloat(this.props.state.result.cgt.minuspResidence.primaryResidenceExclusion* parseFloat(e.ownershipClient)/100) > 0)
            temp.capitalGain =  temp.capitalGain - parseFloat(this.props.state.result.cgt.minuspResidence.primaryResidenceExclusion* parseFloat(e.ownershipClient)/100)
          else
            temp.capitalGain = 0.00

          this.props.state.result.cgt.netClientsCapitalGainDisplay += temp.capitalGain;
          this.props.state.result.cgt.pResidence = temp;
        }
        else
        if(e.category != "primary_residential")
        {
          this.props.state.result.cgt.netClientsCapitalGainDisplay += temp.capitalGain;
        }



        temp.bequethedToSpouse = e.spouseInherit/100 *  temp.capitalGain;
        if(this.props.state.spouseInheritFull == false)
          temp.residueTospouse = this.props.state.residueAmount/100 * parseFloat(temp.capitalGain) * e.estateInherit/100;
        else
        if(this.props.state.spouseInheritFull == true)
          temp.residueTospouse = parseFloat(temp.capitalGain) * e.estateInherit/100;
        temp.netGain = temp.capitalGain - temp.bequethedToSpouse - temp.residueTospouse;
        

        this.props.state.result.cgt.netCgtMarketValue += parseFloat(e.marketValue);
        this.props.state.result.cgt.netClientsBaseCost += parseFloat(e.baseCost);
        this.props.state.result.cgt.netClientsCapitalGain += parseFloat(temp.capitalGain);
        this.props.state.result.cgt.netCashBequestTospouse += parseFloat(temp.bequethedToSpouse);
        this.props.state.result.cgt.netResidueTospouse += parseFloat(temp.residueTospouse);
        this.props.state.result.cgt.netSpouseCapitalGain += parseFloat(temp.netGain);
        


        
        
        
        
        this.props.state.result.cgt.cgtAssets.push(temp);
       
          
      }
      if(this.props.state.result.cgt.netClientsCapitalGain > 0)
        this.props.state.result.cgt.capitalGain = this.props.state.result.cgt.netClientsCapitalGain;


        //Primary residense exlusion
        if(e.category == "primary_residential")
        {
          if(temp.netGain > assumptions.primary_residence_exemption )
            this.props.state.result.cgt.minuspResidence.primaryResidence = assumptions.primary_residence_exemption
          else
            this.props.state.result.cgt.minuspResidence.primaryResidence = temp.netGain

        if(temp.netGain < -1*assumptions.primary_residence_exemption )
            this.props.state.result.cgt.minuspResidence.primaryResidenceLoss = -1*assumptions.primary_residence_exemption
          else
            this.props.state.result.cgt.minuspResidence.primaryResidenceLoss = temp.netGain
        }
           
      
     
    })

    
    this.props.state.result.cgt.minuspResidence.primaryResidenceLossExclusion = -1 * assumptions.primary_residence_exemption;
    this.props.state.result.cgt.minuspResidence.netExclusion = this.props.state.result.cgt.minuspResidence.primaryResidence + this.props.state.result.cgt.minuspResidence.primaryResidenceLoss;
    this.props.state.result.cgt.netMinusExlusion = this.props.state.result.cgt.netClientsCapitalGain - this.props.state.result.cgt.minuspResidence.netExclusion

    this.props.state.result.cgt.minusspouseRollOver.portionBequethedTospouse = this.props.state.result.cgt.netCashBequestTospouse;
    this.props.state.result.cgt.minusspouseRollOver.portionResidueTospouse = this.props.state.result.cgt.netResidueTospouse;
    this.props.state.result.cgt.minusspouseRollOver.netRollOver = this.props.state.result.cgt.minusspouseRollOver.portionBequethedTospouse + this.props.state.result.cgt.minusspouseRollOver.portionResidueTospouse;
    this.props.state.result.cgt.netMinusRollOver = this.props.state.result.cgt.netClientsCapitalGain - this.props.state.result.cgt.minusspouseRollOver.netRollOver;

    this.props.state.result.cgt.minusPreviousLoss = this.props.state.capitalLossAmount;
    this.props.state.result.cgt.netMinusPreviousLoss = this.props.state.result.cgt.netMinusRollOver - this.props.state.result.cgt.minusPreviousLoss;

    this.props.state.result.cgt.minusExclusionAtDeath = assumptions.cgtExclusionAtDeath
    if(this.props.state.result.cgt.netMinusPreviousLoss > 0)
      this.props.state.result.cgt.netMinusExlusionAtDeath = this.props.state.result.cgt.minusExclusionAtDeath
    else
      this.props.state.result.cgt.netMinusExlusionAtDeath = 0;
    
    this.props.state.result.cgt.netCgt = this.props.state.result.cgt.netMinusPreviousLoss - this.props.state.result.cgt.netMinusExlusionAtDeath;

    this.props.state.result.cgt.marginalTax = this.props.state.marginalTax

    this.props.state.result.cgt.inclusionRate = assumptions.inclusion_rate_for_cgt
    
    if(this.props.state.result.cgt.netCgt > 0)
      this.props.state.result.cgt.cgtPayable = this.props.state.result.cgt.netCgt * this.props.state.result.cgt.marginalTax/100 * this.props.state.result.cgt.inclusionRate/100
    else
    this.props.state.result.cgt.cgtPayable = 0;
    
    
    //console.log(this.props.state.result)
        
       

    this.calcAccrual();

  }

  calcEstateDuty = () =>
  {
    this.props.state.assets.map((e, i) => 
    {
      if(e.category == "farms_owned")
      {
        if(this.props.state.percentageOnFarm)
          this.props.state.result.estateDuty.assets.netFarms += e.ownershipClient/100 * e.marketValue * 0.7;
        else
          this.props.state.result.estateDuty.assets.netFarms += e.ownershipClient/100 * e.marketValue;
      }
      else
        if(e.category == "usufruct_annuity_charged_on_property_or_similar_right")
          this.props.state.result.estateDuty.assets.netDeemedAssets += e.ownershipClient/100 * e.marketValue;
      else
        this.props.state.result.estateDuty.assets.netAssets += e.ownershipClient/100 * e.marketValue;
    })

    this.props.state.policy.map((e, i) => 
    {
      if(!e.dutyExcempt)
        if(e.LifeAssured == "client")
        {
          this.props.state.result.estateDuty.assets.netPoliciesOnLife += parseFloat(e.death);

          this.props.state.result.estateDuty.deductions.netPoliciesToSpouse += parseFloat(e.death) * e.spouseInherit/100
        }
          else 
            if(e.party == "client")
              this.props.state.result.estateDuty.assets.netPoliciesWithChash += parseFloat(e.cashValue);

       
    })

    this.props.state.result.estateDuty.assets.netEstateAssets =  parseFloat(this.props.state.result.estateDuty.assets.netFarms) + 
                                                           parseFloat(this.props.state.result.estateDuty.assets.netDeemedAssets) + 
                                                           parseFloat(this.props.state.result.estateDuty.assets.netAssets) + 
                                                           parseFloat(this.props.state.result.estateDuty.assets.netPoliciesOnLife) + 
                                                           parseFloat(this.props.state.result.estateDuty.assets.netPoliciesWithChash) + 
                                                           parseFloat(this.props.state.result.estateDuty.assets.netAccrualClaim);
                                                          
    
     this.props.state.result.estateDuty.deductions.netLiabilities = this.props.state.result.balanceSheet.netLiabilitiesClient;
     this.props.state.result.estateDuty.deductions.netAdministration = parseFloat(this.props.state.adminCost);
     this.props.state.result.estateDuty.deductions.netFuneral =  parseFloat(this.props.state.funeralCost);
     this.props.state.result.estateDuty.deductions.netMastersFee = assumptions.masters_fees;
     this.props.state.result.estateDuty.deductions.netExectutorsFee = this.props.state.result.executorFees.executorFee;
     this.props.state.result.estateDuty.deductions.netCapitalGainTax = this.props.state.result.cgt.cgtPayable;

     this.props.state.assets.map((e, i) => 
    {
      if((e.category == "primary_residential" || e.category == "other_residential"))
        this.props.state.result.estateDuty.deductions.netTransferCosts += parseFloat(e.marketValue)// * e.ownershipClient/100 //Should this only be the Client's portion??

        this.props.state.result.estateDuty.deductions.netBequethedAssets += parseFloat( e.marketValue)* e.ownershipClient/100 * e.spouseInherit /100
    })
    this.props.state.result.estateDuty.deductions.netTransferCosts = parseFloat(this.props.state.result.estateDuty.deductions.netTransferCosts) * parseFloat(assumptions.transfer_costs) / 100;

    this.props.state.needs.cashBequests.map((e, i) => 
    {
      if(e.category == "cashBequest" || e.category == "cashBequestCharity")
      {
        this.props.state.result.estateDuty.deductions.netCashBequestTospouse += e.mounthlyAmount * e.spouseInherit /100 

        this.props.state.result.estateDuty.deductions.netCashBequestToCharity += e.mounthlyAmount * e.charityInherit /100 
      }
        
    })
    this.calcResidue();
    if(this.props.state.spouseInheritFull == false)
      this.props.state.result.estateDuty.deductions.netResidueTospouse =  this.props.state.result.residue.residueBeforeEstateDuty * this.props.state.residueAmount /100
    else
    this.props.state.result.estateDuty.deductions.netResidueTospouse =  this.props.state.result.residue.residueBeforeEstateDuty

    this.props.state.result.estateDuty.deductions.netAccrualClaim = this.props.state.result.accrual.clainBySpouse;

    this.props.state.result.estateDuty.deductions.netDeductions =  parseFloat(this.props.state.result.estateDuty.deductions.netLiabilities) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions.netAdministration) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions.netFuneral) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions.netMastersFee) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions.netExectutorsFee) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions.netCapitalGainTax) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions.netTransferCosts) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions.netBequethedAssets) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions.netCashBequestTospouse) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions.netCashBequestToCharity) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions.netResidueTospouse) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions.netPoliciesToSpouse) +
                                                                   parseFloat(this.props.state.result.estateDuty.deductions. netAccrualClaim);

    this.props.state.result.estateDuty.netEstate = this.props.state.result.estateDuty.assets.netEstateAssets - this.props.state.result.estateDuty.deductions.netDeductions;
    this.props.state.result.estateDuty.minusRebate = assumptions.estate_duty_exemption;
    if(this.props.state.spouseDeath)
      this.props.state.result.estateDuty.minusRebateFromPreviousSpouse =  parseFloat(this.props.state.rebateUsed);
    else
      this.props.state.result.estateDuty.minusRebateFromPreviousSpouse = 0.00; //check if correct

    this.props.state.result.estateDuty.taxableEstate = this.props.state.result.estateDuty.netEstate - this.props.state.result.estateDuty.minusRebate - this.props.state.result.estateDuty.minusRebateFromPreviousSpouse;
    if(this.props.state.result.estateDuty.taxableEstate < 0)
      this.props.state.result.estateDuty.taxableEstate = 0.00;
    
    if(this.props.state.result.estateDuty.taxableEstate <= 30000000)
      this.props.state.result.estateDuty.estateDutyPayable = this.props.state.result.estateDuty.taxableEstate * assumptions.estateDutyLT /100
    else
    this.props.state.result.estateDuty.estateDutyPayable = this.props.state.result.estateDuty.taxableEstate * assumptions.estateDutyGT /100

    this.props.state.policy.map((e, i) => 
    {
      if(!e.dutyExcempt)
      {
        this.props.state.result.estateDuty.payableByOther += parseFloat(e.death) * e.otherInherit/100
      }
    })

    if(this.props.state.result.estateDuty.netEstate * this.props.state.result.estateDuty.estateDutyPayable != 0)
      this.props.state.result.estateDuty.payableByOther = this.props.state.result.estateDuty.payableByOther/this.props.state.result.estateDuty.netEstate * this.props.state.result.estateDuty.estateDutyPayable;
    else
      this.props.state.result.estateDuty.payableByOther = 0;
    this.props.state.result.estateDuty.payableByEstate = this.props.state.result.estateDuty.estateDutyPayable - this.props.state.result.estateDuty.payableByOther;


    this.props.state.result.residue.minusEstateDuty = this.props.state.result.estateDuty.payableByEstate;
    this.props.state.result.residue.residue = this.props.state.result.residue.residueBeforeEstateDuty - this.props.state.result.residue.minusEstateDuty;
    if(this.props.state.result.residue.residue < 0)
      this.props.state.result.residue.residue = 0.00;


    this.calcLiquidity();

  }

  
  calcLiquidity = () =>
  {
    this.props.state.result.liquidity.cashNeeded.netCgt = this.props.state.result.cgt.cgtPayable;
    this.props.state.result.liquidity.cashNeeded.netLiabilities = this.props.state.result.balanceSheet.netLiabilitiesClient;
    this.props.state.result.liquidity.cashNeeded.netExectutorsFee = this.props.state.result.executorFees.executorFee;
    this.props.state.result.liquidity.cashNeeded.netEstateDuty = this.props.state.result.estateDuty.payableByEstate;
    this.props.state.result.liquidity.cashNeeded.netOtherCosts = parseFloat(this.props.state.result.estateDuty.deductions.netAdministration) + parseFloat(this.props.state.result.estateDuty.deductions.netFuneral) + parseFloat(this.props.state.result.estateDuty.deductions.netMastersFee) + parseFloat(this.props.state.result.estateDuty.deductions.netTransferCosts);
    
    this.props.state.needs.cashBequests.map((e, i) => 
    {
      if((e.category == "cashBequest" || e.category == "cashBequestCharity") && e.death)
      {
        this.props.state.result.liquidity.cashNeeded.netCashBequests +=  parseFloat(e.mounthlyAmount)
      }
        
    })

    this.props.state.result.liquidity.cashNeeded.netAccrualClaim =  this.props.state.result.accrual.clainBySpouse - this.props.state.result.estateDuty.deductions.netResidueTospouse              //First need to calculate accrual.
    //console.log(this.props.state.result.liquidity.cashNeeded)
    if(this.props.state.result.liquidity.cashNeeded.netAccrualClaim < 0)
      this.props.state.result.liquidity.cashNeeded.netAccrualClaim = 0.00
    this.props.state.policy.map((e, i) => 
    {
      if(e.LifeAssured != "client" && e.party == "client")
      {
        this.props.state.result.liquidity.cashNeeded.netBequethedLiquidAssets += parseFloat(e.cashValue) * (1- parseFloat(e.estateInherit)/100);
        this.props.state.result.liquidity.cashAvailable.netCashAssets +=  parseFloat(e.cashValue);
      }
        
    })
    
    this.props.state.assets.map((e, i) => 
    {
      if((e.category != "primary_residential" && e.category != "other_residential" && e.category != "farms_owned" && e.category != "usufruct_annuity_charged_on_property_or_similar_right") || e.liquid)
      {
        if(e.liquid)
        {
          this.props.state.result.liquidity.cashAvailable.netCashAssets +=  parseFloat(e.marketValue);
          this.props.state.result.liquidity.cashNeeded.netBequethedLiquidAssets +=  parseFloat(e.marketValue) * (1- e.estateInherit/100);
        }
        else
        if(e.category == "Investments")
          this.props.state.result.liquidity.cashAvailable.netLiquidInvestments +=  parseFloat(e.marketValue);
      }
        
    })

    
        this.props.state.result.liquidity.cashAvailable.netPolicies += this.props.state.result.executorFees.pToEstate;
   
        this.props.state.result.liquidity.cashNeeded.netCashNeeded = parseFloat(this.props.state.result.liquidity.cashNeeded.netCgt) +
                                                                  parseFloat(this.props.state.result.liquidity.cashNeeded.netLiabilities) + 
                                                                  parseFloat(this.props.state.result.liquidity.cashNeeded.netExectutorsFee) + 
                                                                  parseFloat(this.props.state.result.liquidity.cashNeeded.netEstateDuty) +
                                                                  parseFloat(this.props.state.result.liquidity.cashNeeded.netOtherCosts) +
                                                                  parseFloat(this.props.state.result.liquidity.cashNeeded.netBequethedLiquidAssets) +
                                                                  parseFloat(this.props.state.result.liquidity.cashNeeded.netCashBequests) +
                                                                  parseFloat(this.props.state.result.liquidity.cashNeeded.netAccrualClaim)
     
    this.props.state.result.liquidity.cashAvailable.netCashAvailable = this.props.state.result.liquidity.cashAvailable.netCashAssets +
                                                                        this.props.state.result.liquidity.cashAvailable.netLiquidInvestments +
                                                                        this.props.state.result.liquidity.cashAvailable.netPolicies
                                                    
    this.props.state.result.liquidity.cash = this.props.state.result.liquidity.cashAvailable.netCashAvailable - this.props.state.result.liquidity.cashNeeded.netCashNeeded;

    //this.calcResidue();
    this.calcDeathProv();

  }

  calcAccrual = () =>
  {
    this.props.state.result.accrual.current.valueOfAssets.client = parseFloat(this.props.state.result.balanceSheet.netAssetsClient) + parseFloat(this.props.state.result.balanceSheet.netPoliciesClient);
    this.props.state.result.accrual.current.valueOfAssets.spouse = parseFloat(this.props.state.result.balanceSheet.netAssetsSpouse) + parseFloat(this.props.state.result.balanceSheet.netPoliciesSpouse);
    
    this.props.state.result.accrual.current.valueOfPolicies = this.props.state.result.executorFees.pToEstate;
/*
    this.props.state.result.balanceSheet.policies.map((e, i) => 
    {
      if(e.amountClient)
        this.props.state.result.accrual.current.valueOfAssets.client += parseFloat(e.amountClient)
      if(e.amountSpouse)
        this.props.state.result.accrual.current.valueOfAssets.spouse += parseFloat(e.amountSpouse)
    })*/

    this.props.state.result.accrual.current.minusLiabilities.client = this.props.state.result.balanceSheet.netLiabilitiesClient;
    this.props.state.result.accrual.current.minusLiabilities.spouse = this.props.state.result.balanceSheet.netLiabilitiesSpouse;

    this.props.state.result.accrual.current.netValue.client = parseFloat(this.props.state.result.accrual.current.valueOfAssets.client) +
                                                              parseFloat(this.props.state.result.accrual.current.valueOfPolicies) -
                                                              parseFloat(this.props.state.result.accrual.current.minusLiabilities.client)

    this.props.state.result.accrual.current.netValue.spouse = parseFloat(this.props.state.result.accrual.current.valueOfAssets.spouse) -
                                                              parseFloat(this.props.state.result.accrual.current.minusLiabilities.spouse)

    this.props.state.result.accrual.assetValueExcluded.client = this.props.state.accrualExcludedClient;
    this.props.state.result.accrual.assetValueExcluded.spouse = this.props.state.accrualExcludedSpouse;

    this.props.state.result.accrual.atMarriage.valueANC.client = this.props.state.accrualExcludedMarrageClient;
    this.props.state.result.accrual.atMarriage.valueANC.spouse = this.props.state.accrualExcludedMarrageSpouse;

    this.props.state.result.accrual.netAccrual.client = parseFloat(this.props.state.result.accrual.current.netValue.client) - parseFloat(this.props.state.result.accrual.assetValueExcluded.client);
    this.props.state.result.accrual.netAccrual.spouse = parseFloat(this.props.state.result.accrual.current.netValue.spouse) - parseFloat(this.props.state.result.accrual.assetValueExcluded.spouse);

    if(this.props.state.result.accrual.netAccrual.client < 0)
      this.props.state.result.accrual.netAccrual.client = 0.00

    if(this.props.state.result.accrual.netAccrual.spouse < 0)
      this.props.state.result.accrual.netAccrual.spouse = 0.00

    if(this.props.state.result.accrual.netAccrual.spouse - this.props.state.result.accrual.netAccrual.client > 0)
      this.props.state.result.accrual.claimAgainstSpouse = (this.props.state.result.accrual.netAccrual.spouse - this.props.state.result.accrual.netAccrual.client)/2

    if(this.props.state.result.accrual.netAccrual.client - this.props.state.result.accrual.netAccrual.spouse  > 0)
      this.props.state.result.accrual.clainBySpouse = (this.props.state.result.accrual.netAccrual.client - this.props.state.result.accrual.netAccrual.spouse)/2

    this.calcEstateDuty();

  }

  calcResidue = () =>
  {
    this.props.state.result.residue.totalAssets = this.props.state.result.estateDuty.assets.netEstateAssets;
    //this.props.state.result.residue.policies = 0.00; // take policies excemt no!! and 100% - estate%    
    
    this.props.state.policy.map((e, i) => 
    {
      if(!e.dutyExcempt && e.LifeAssured == "client")
        this.props.state.result.residue.policies += parseFloat(e.death) *(1 - e.estateInherit/100)
        
    })

    this.props.state.assets.map((e, i) => 
    {
      this.props.state.result.residue.bequestsToOther += e.marketValue * e.ownershipClient/100 * e.otherInherit/100 + e.marketValue * e.ownershipClient/100 * e.charityInherit/100;
      this.props.state.result.residue.bequestsToSpouse += e.marketValue * e.ownershipClient/100 * e.spouseInherit/100;
        
    })

    this.props.state.needs.cashBequests.map((e, i) => 
    {
      if((e.category == "cashBequest" || e.category == "cashBequestCharity") && e.death)
      {
        this.props.state.result.residue.cashBequestsToOther += e.mounthlyAmount * e.otherInherit/100 + e.mounthlyAmount * e.charityInherit/100;
        this.props.state.result.residue.cashBequestsToSpouse += e.mounthlyAmount * e.spouseInherit/100;
      }
    })

    this.props.state.result.residue.liabilities = this.props.state.result.balanceSheet.netLiabilitiesClient;
      this.props.state.result.residue.costs =  parseFloat(this.props.state.result.estateDuty.deductions.netAdministration) + 
                                               parseFloat(this.props.state.result.estateDuty.deductions.netFuneral) +
                                               parseFloat(this.props.state.result.estateDuty.deductions.netMastersFee) +
                                               parseFloat(this.props.state.result.estateDuty.deductions.netExectutorsFee) +
                                               parseFloat(this.props.state.result.estateDuty.deductions.netCapitalGainTax) +
                                               parseFloat(this.props.state.result.estateDuty.deductions.netTransferCosts)

    this.props.state.result.residue.accrualClaimBySpouse = this.props.state.result.accrual.clainBySpouse;

    this.props.state.result.residue.minus =  parseFloat(this.props.state.result.residue.policies) +
                                             parseFloat(this.props.state.result.residue.bequestsToOther) +
                                             parseFloat(this.props.state.result.residue.cashBequestsToOther) +
                                             parseFloat(this.props.state.result.residue.bequestsToSpouse) +
                                             parseFloat(this.props.state.result.residue.cashBequestsToSpouse) +
                                             parseFloat(this.props.state.result.residue.liabilities) +
                                             parseFloat(this.props.state.result.residue.costs) +
                                             parseFloat(this.props.state.result.residue.accrualClaimBySpouse)
    
    this.props.state.result.residue.residueBeforeEstateDuty = this.props.state.result.residue.totalAssets - this.props.state.result.residue.minus;
    if(this.props.state.result.residue.residueBeforeEstateDuty < 0)
      this.props.state.result.residue.residueBeforeEstateDuty = 0.00;

    
    
    
    
  }

  calcDeathProv()
  {
    this.props.state.result.deathProvision.liquidity = this.props.state.result.liquidity.cash;
    this.props.state.result.deathProvision.surplusToOther =  this.props.state.result.deathProvision.liquidity * ( 1 - this.props.state.residueAmount /100)
    if(this.props.state.result.deathProvision.surplusToOther < 0)
      this.props.state.result.deathProvision.surplusToOther = 0;

    this.props.state.needs.capitalNeeds.map((e, i) => 
    {
      this.props.state.result.deathProvision.capitalNeed += parseFloat(e.mounthlyAmount)
    })

    this.props.state.result.deathProvision.netNeed = parseFloat(this.props.state.result.deathProvision.liquidity) - parseFloat(this.props.state.result.deathProvision.surplusToOther) - parseFloat(this.props.state.result.deathProvision.capitalNeed)
    

    this.props.state.policy.map((e, i) => 
    {
        if(e.LifeAssured == "client")
        {
          this.props.state.result.deathProvision.provision.policies += ( (e.death * e.spouseInherit/100) +  (e.death * e.dependentsInherit/100))
        }

    })

    this.props.state.needs.cashBequests.map((e, i) => 
    {
          this.props.state.result.deathProvision.provision.cashToSpouse += ( (e.mounthlyAmount * e.spouseInherit/100) +  (e.mounthlyAmount * e.dependentsInherit/100))
    })

    this.props.state.assets.map((e, i) => 
    {
        if(e.liquid)
          this.props.state.result.deathProvision.provision.cashToSpouse += ( (e.marketValue * e.spouseInherit/100) +  (e.marketValue * e.dependentsInherit/100))
    })

    this.props.state.result.deathProvision.provision.capitalLiquidity = this.props.state.result.deathProvision.provision.cashToSpouse + this.props.state.result.deathProvision.provision.policies + this.props.state.result.deathProvision.netNeed

    this.props.state.needs.incomeNeeds.map((e, i) => 
    {
          var need = {};
          need.mounthlyAmount = parseFloat(e.mounthlyAmount)
          need.annualIncrease = parseFloat(e.annualIncrease)
          need.yearsPayable = parseFloat(e.yearsPayable) ;
          this.props.state.result.deathProvision.needAtDeath.push(need)
    })

    this.props.state.needs.incomeStreams.map((e, i) => 
    {
          var stream = {};
          stream.mounthlyAmount = parseFloat(e.mounthlyAmount);
          stream.annualIncrease = parseFloat(e.annualIncrease);
          stream.yearsPayable = parseFloat(e.yearsPayable) ;
          this.props.state.result.deathProvision.incomeProvision.push(stream)
    })
    //this.props.state.result.deathProvision.monthsProvisioned
    var capitalProv = {};
    var currentIncome = 0.00;
    var currentNeed = 0.00;
    capitalProv.capital = this.props.state.result.deathProvision.provision.capitalLiquidity;
    capitalProv.growthP = parseFloat(this.props.state.investmentGrowth)
    capitalProv.growth = capitalProv.capital * parseFloat(this.props.state.investmentGrowth)/100 /12
    capitalProv.drawdown = 0.00

    this.props.state.result.deathProvision.needAtDeath.map((e, i) => 
    {
      capitalProv.drawdown += e.mounthlyAmount;
      currentNeed += e.mounthlyAmount;
    })

    this.props.state.result.deathProvision.incomeProvision.map((e, i) => 
    {
      capitalProv.drawdown -= e.mounthlyAmount;
      currentIncome += e.mounthlyAmount;
    })

    if(capitalProv.capital > 0)
    {
      this.props.state.result.deathProvision.capitalProvisioning.push(capitalProv)
      this.calcTimeProvisioned(currentIncome,currentNeed)
    }
    
    this.props.state.result.deathProvision.monthsProvisioned = this.props.state.result.deathProvision.capitalProvisioning.length;
    if(this.props.state.result.deathProvision.monthsProvisioned > 720)
      this.props.state.result.deathProvision.monthsProvisioned = "> 720"

  }

  calcTimeProvisioned(currentIncome, currentNeed)
  {
    
    var capitalProv = {};
    capitalProv.capital = this.props.state.result.deathProvision.capitalProvisioning[this.props.state.result.deathProvision.capitalProvisioning.length -1].capital 
                        - this.props.state.result.deathProvision.capitalProvisioning[this.props.state.result.deathProvision.capitalProvisioning.length -1].drawdown
    
    if(capitalProv.capital < 0 || this.props.state.result.deathProvision.capitalProvisioning.length > 720)
      return;
    capitalProv.growthP = parseFloat(this.props.state.investmentGrowth)
    capitalProv.growth = capitalProv.capital * parseFloat(this.props.state.investmentGrowth)/100 /12
    
    ////console.log(currentNeed + " - " + currentIncome + " = " +  capitalProv.drawdown)
    if(this.props.state.result.deathProvision.capitalProvisioning.length % 12 == 0)
    {
      currentNeed = 0.00;
      this.props.state.result.deathProvision.needAtDeath.map((e, i) => 
      {
        e.yearsPayable -= 1;
        if(e.yearsPayable <= 0)
          e.mounthlyAmount = 0;
        e.mounthlyAmount = parseFloat(e.mounthlyAmount) + (parseFloat(e.mounthlyAmount) * parseFloat(e.annualIncrease)/100)
        currentNeed += e.mounthlyAmount;
      })
      
    }
      

    if(this.props.state.result.deathProvision.capitalProvisioning.length % 12 == 0)
    {
      currentIncome = 0;
      this.props.state.result.deathProvision.incomeProvision.map((e, i) => 
      {
        e.yearsPayable -= 1;
        if(e.yearsPayable <= 0)
          e.mounthlyAmount = 0;
          e.mounthlyAmount = parseFloat(e.mounthlyAmount) + (parseFloat(e.mounthlyAmount) * parseFloat(e.annualIncrease)/100)
          currentIncome += e.mounthlyAmount;
      })
    }

    capitalProv.drawdown = currentNeed - currentIncome;
     

    
    this.props.state.result.deathProvision.capitalProvisioning.push(capitalProv)

    this.calcTimeProvisioned(currentIncome, currentNeed)

  }

  
  
  
  render() {
    
    


    let { checkValidation } = this.props;

    this.calcBalanceSheet();

    var clientD = "";
    if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname
      console.log(this.props.state)

    return (
      <div className="contentWithStepper" style={{ width: "120%", marginLeft: "-10%", flex: 1, height:"fit-content" }}>
        <Card>
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={clientD}
              headline={"Asset Distribution at Death"}
            />
            <ExpansionPanel defaultExpanded={0 === 0} key={101} >

            <Table className="customTable1">
                    <TableHead className="fixedHead">
                      <TableRow>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("0em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}></Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("15em")}

                        >
                           <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"500"}}>
                          Executor's Fee
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("15em")}


                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"500"}}>
                          Estate Duty
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("15em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"500"}}>CGT</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("15em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"500"}}>Liquidity</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("15em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"500"}}>Accrual</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("15em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"500"}}>Residue</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("15em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"500"}}>Provisioned for</Typography>
                        </TableCell>


                      </TableRow>

                    </TableHead>
                    <TableBody>
                    <TableRow>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}></Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("10em")}

                        >
                          <Typography style={{ textAlign: "center" }}>
                          R {grandSeperator(this.props.state.result.executorFees.executorFee)}
                          </Typography>
                          
                          
                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("10em")}


                        >
                         <Typography style={{ textAlign: "center" }}>R {grandSeperator(this.props.state.result.estateDuty.estateDutyPayable)}</Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("10em")}
                        >
                         <Typography style={{ textAlign: "center" }}>R {grandSeperator(this.props.state.result.cgt.cgtPayable)}</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("10em")}
                        >
                          <Typography style={{ textAlign: "center" }}>R {grandSeperator(this.props.state.result.liquidity.cash)}</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("10em")}
                        >
                          <Typography style={{ textAlign: "center" }}>R {grandSeperator(this.props.state.result.accrual.claimAgainstSpouse - this.props.state.result.accrual.clainBySpouse)}</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("10em")}
                        >
                          <Typography style={{ textAlign: "center" }}>R {grandSeperator(this.props.state.result.residue.residue)}</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("10em")}
                        >
                          <Typography style={{ textAlign: "center" }}>{toInteger(this.props.state.result.deathProvision.monthsProvisioned/12)}Y {" "}{this.props.state.result.deathProvision.monthsProvisioned%12}M</Typography>
                        </TableCell>


                      </TableRow>

                    
                    </TableBody>
                  </Table>

            </ExpansionPanel>
 
            <ExpansionPanel defaultExpanded={0 === 0} key={101} >
            <ExpansionPanelDetails>
            <Grid container spacing={24} >
            <Table className="customTable1">
                    <TableHead className="fixedHead">
                    
                      <TableRow>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("12em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", fontWeight:"bold" }}></Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", fontWeight:"500" }}>Value</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px', fontWeight:"500" }}>
                          Estate/Residue
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}


                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"500"}}>
                          Spouse
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"500"}}>Dependents</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"500"}}>Trust</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"500"}}>Charity </Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"500"}}>Other </Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}> </Typography>
                        </TableCell>

                       


                      </TableRow>

                    </TableHead>
                    <TableBody>

                    
                    </TableBody>
                  </Table>
                  </Grid>
                  </ExpansionPanelDetails>
            </ExpansionPanel>

                 
<ExpansionPanel defaultExpanded={0 === 1} key={1} onClick={(event) => this.fixedAssestsExpand(event)} >
              <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
                <Table>
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("12em")}
                      //colSpan={6}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        Assets
                      </Typography>
                    </TableCell>
                    <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom', fontStyle:"oblique", fontWeight:"420" }}>
                                R {grandSeperator(this.getAssetTotalValue())}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom', fontStyle:"oblique", fontWeight:"420" }}>
                                R {grandSeperator(this.getInheretValue("assets", "estateInherit"))}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom', fontStyle:"oblique", fontWeight:"420" }}>
                                R {grandSeperator(this.getInheretValue("assets", "spouseInherit"))}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom', fontStyle:"oblique", fontWeight:"420" }}>
                                R {grandSeperator(this.getInheretValue("assets", "dependentsInherit"))}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom', fontStyle:"oblique", fontWeight:"420" }}>
                                R {grandSeperator(this.getInheretValue("assets", "trustInherit"))}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {grandSeperator(this.getInheretValue("assets", "otherInherit"))}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {grandSeperator(this.getInheretValue("assets", "otherInherit"))}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                          style={colwidth("6em")}>
                         
                        </TableCell>


                  </TableRow>
                 
                </Table>

              </ExpansionPanelSummary>
              <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                      <TableRow>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("12em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Asset</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"420"}}>
                            Value
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}


                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom', fontWeight:"420" }}>
                          Estate/Residue
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Spouse</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", fontWeight:"420" }}>Dependents</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", fontWeight:"420" }}>Trust</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", fontWeight:"420" }}>Charity</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", fontWeight:"420" }}>Other</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Convert To Liquid? </Typography>
                        </TableCell>


                      </TableRow>

                    </TableHead>
                    <TableBody>

                     {
                        this.props.state.assets.map((e, i) => 
                        {
                          if(!e.liquid && e.ownershipClient > 0)
                          return (
                              <TableRow key={i}>

                              <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {this.props.state.assets[i].description}
                                      </Typography>
                                </TableCell>

                                <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        R {grandSeperator(this.getAssetValue(i))}
                                      </Typography>
                                </TableCell>

                                {/*<CustomField
                                  name={'assets.estate' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeEstate(f,h)
                                    }}
                                  />*/}
                                  <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {100 - this.props.state.assets[i].spouseInherit - this.props.state.assets[i].dependentsInherit - this.props.state.assets[i].trustInherit
                                         - this.props.state.assets[i].charityInherit - this.props.state.assets[i].otherInherit }%
                                      </Typography>
                                  </TableCell>


                                 <CustomField
                                  name={'assets.spouse' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeSpouse(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'assets.dependents' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeDependents(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'assets.trust' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeTrust(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'assets.charity' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeCharity(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'assets.other' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeOther(f,h)
                                    }}
                                />

                              <TableCell className="cellPaddingSmall">
                                  <FormControl fullWidth>
                                  <Button
                                    name={"convert" + i}
                                    key = {"convert" + i}
                                    variant="contained"
                                    
                                    className="fab"
                                    color="primary"
                                    
                                    onClick={(e)=> {
                                      this.convertAsset(e)
                                     ////console.log(inspect(e.currentTarget))
                                     //alert(e.currentTarget.name)
                                    }}
                                  >
                                    Convert
                                  </Button>
                                  </FormControl>
                                </TableCell>

                                 

                                
                              </TableRow>
                          )
                        })
                     }

                      <TableRow>



                      <TableCell className="cellPaddingSmall"
                      style={colwidth("12em")}>
                          
                            
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                
                               </Typography>
                            
                         
                        </TableCell>

                      <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom', fontStyle:"oblique", fontWeight:"420" }}>
                                R {this.getAssetTotalValue()}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom', fontStyle:"oblique", fontWeight:"420" }}>
                                R {this.getInheretValue("assets", "estateInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom', fontStyle:"oblique", fontWeight:"420" }}>
                                R {this.getInheretValue("assets", "spouseInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom', fontStyle:"oblique", fontWeight:"420", fontStyle:"oblique", fontWeight:"420" }}>
                               R {this.getInheretValue("assets", "dependentsInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom', fontStyle:"oblique", fontWeight:"420" }}>
                                R {this.getInheretValue("assets", "trustInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assets", "charityInherit")}
                               </Typography>
                            }
                         
                        </TableCell>
                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.fixedAssests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assets", "otherInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                
                               </Typography>
                            
                         
                        </TableCell>



                      </TableRow>

                    </TableBody>
                  </Table>

                </Grid>

              </ExpansionPanelDetails>

            </ExpansionPanel>
            
            <ExpansionPanel defaultExpanded={0 === 1} key={1} onClick={(event) => this.liquidAssestsExpand(event)} >
              <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
                <Table>
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("12em")}
                      //colSpan={6}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        Liquid Assets
                      </Typography>
                    </TableCell>
                    <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getAssetTotalValue("l")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "estateInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "spouseInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "dependentsInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "trustInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "charityInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "otherInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                       


                        <TableCell className="cellPaddingSmall"
                          style={colwidth("6em")}>
                         
                        </TableCell>


                  </TableRow>
                 
                </Table>

              </ExpansionPanelSummary>
              <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                      <TableRow>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("12em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Asset</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"420"}}>
                            Value
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}


                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"420"}}>
                          Estate/Residue
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Spouse</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Dependents</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Trust</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Charity</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Other</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Convert To Fixed? </Typography>
                        </TableCell>


                      </TableRow>

                    </TableHead>
                    <TableBody>

                    {
                        this.props.state.assets.map((e, i) => 
                        {
                          if(e.liquid && e.ownershipClient > 0)
                          return (
                              <TableRow key={i}>

                              <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {this.props.state.assets[i].description}
                                      </Typography>
                                </TableCell>

                                <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        R {grandSeperator(this.getAssetValue(i))}
                                      </Typography>
                                </TableCell>

                               {/* <CustomField
                                  name={'assets.estate' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeEstate(f,h)
                                    }}
                                  /> */}
                                  <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {this.props.state.assets[i].estateInherit}%
                                      </Typography>
                                  </TableCell>

                                 <CustomField
                                  name={'assets.spouse' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeSpouse(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'assets.dependents' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeDependents(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'assets.trust' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeTrust(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'assets.charity' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeCharity(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'assets.other' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeOther(f,h)
                                    }}
                                />

                              <TableCell className="cellPaddingSmall">
                                  <FormControl fullWidth>
                                  <Button
                                    name={"convert" + i}
                                    key = {"convert" + i}
                                    variant="contained"
                                    
                                    className="fab"
                                    color="primary"
                                    
                                    onClick={(e)=> {
                                      this.convertAsset(e)
                                     ////console.log(inspect(e.currentTarget))
                                     //alert(e.currentTarget.name)
                                    }}
                                  >
                                    Convert
                                  </Button>
                                  </FormControl>
                                </TableCell>

                                 

                                
                              </TableRow>
                          )
                        })
                     }

{
                        this.props.state.policy.map((e, i) => 
                        {
                          if(e.LifeAssured != "client" && e.party == "client")
                          return (
                              <TableRow key={i}>

                              <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {this.props.state.policy[i].description}
                                      </Typography>
                                </TableCell>

                                <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        R {grandSeperator(this.props.state.policy[i].cashValue)}
                                      </Typography>
                                </TableCell>

                               { /*<CustomField
                                  name={'policy.estate' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeEstate(f,h)
                                    }}
                                  />*/}
                                  <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {this.props.state.policy[i].estateInherit}%
                                      </Typography>
                                  </TableCell>

                                 <CustomField
                                  name={'policy.spouse' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeSpouse(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'policy.dependents' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeDependents(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'policy.trust' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeTrust(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'policy.charity' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeCharity(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'policy.other' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeOther(f,h)
                                    }}
                                />

                              <TableCell className="cellPaddingSmall">
                                  
                                  
                                  
                                </TableCell>

                                 

                                
                              </TableRow>
                          )
                        })
                     }

                      <TableRow>



                      <TableCell className="cellPaddingSmall"
                      style={colwidth("12em")}>
                          
                            
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                
                               </Typography>
                            
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getAssetTotalValue("l")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "estateInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "spouseInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "dependentsInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "trustInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "charityInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.liquidAssets == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("assetsL", "otherInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                       
                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                
                               </Typography>
                            
                         
                        </TableCell>



                      </TableRow>

                    </TableBody>
                  </Table>

                </Grid>

              </ExpansionPanelDetails>

            </ExpansionPanel>

            <ExpansionPanel defaultExpanded={0 === 1} key={1} onClick={(event) => this.policiesExpand(event)} >
              <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
                <Table>
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("12em")}
                      //colSpan={6}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        Policies
                      </Typography>
                    </TableCell>
                    <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getPolicyTotalValue()}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "estateInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "spouseInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "dependentsInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "trustInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "charityInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "otherInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                       


                        <TableCell className="cellPaddingSmall"
                          style={colwidth("6em")}>
                         
                        </TableCell>


                  </TableRow>
                 
                </Table>

              </ExpansionPanelSummary>
              <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                      <TableRow>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("12em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Policy</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"420"}}>
                            Value
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}


                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"420"}}>
                          Estate/Residue
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Spouse</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Dependents</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Trust</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Charity</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Other</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Estate Duty Exempt </Typography>
                        </TableCell>


                      </TableRow>

                    </TableHead>
                    <TableBody>

                    {
                        this.props.state.policy.map((e, i) => 
                        {
                          if(e.LifeAssured == "client")
                          return (
                              <TableRow key={i}>

                              <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {this.props.state.policy[i].description}
                                      </Typography>
                                </TableCell>

                                <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        R {grandSeperator(this.props.state.policy[i].death)}
                                      </Typography>
                                </TableCell>

                                {/*<CustomField
                                  name={'policy.estate' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeEstate(f,h)
                                    }}
                                  />*/}
                                  <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {this.props.state.policy[i].estateInherit}%
                                      </Typography>
                                  </TableCell>

                                 <CustomField
                                  name={'policy.spouse' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeSpouse(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'policy.dependents' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeDependents(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'policy.trust' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeTrust(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'policy.charity' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeCharity(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'policy.other' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeOther(f,h)
                                    }}
                                />

                              <TableCell className="cellPaddingSmall">
                                  
                                  {this.checkItem("", "dutyExcempt" + i, this.changeDutyExcempt)}
                                  
                                </TableCell>

                                 

                                
                              </TableRow>
                          )
                        })
                     }

                      <TableRow>



                      <TableCell className="cellPaddingSmall"
                      style={colwidth("12em")}>
                          
                            
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                
                               </Typography>
                            
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getPolicyTotalValue()}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "estateInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "spouseInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "dependentsInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "trustInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "charityInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.policies == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("policy", "otherInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                       
                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                
                               </Typography>
                            
                         
                        </TableCell>



                      </TableRow>

                    </TableBody>
                  </Table>

                </Grid>

              </ExpansionPanelDetails>

            </ExpansionPanel>

            <ExpansionPanel defaultExpanded={0 === 1} key={1} onClick={(event) => this.bequestsExpand(event)} >
              <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
                <Table>
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("12em")}
                      //colSpan={6}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        Cash Bequests
                      </Typography>
                    </TableCell>
                    <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getBequestsTotalValue()}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "estateInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "spouseInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "dependentsInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "trustInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "charityInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "otherInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                       


                        <TableCell className="cellPaddingSmall"
                          style={colwidth("6em")}>
                         
                        </TableCell>


                  </TableRow>
                 
                </Table>

              </ExpansionPanelSummary>
              <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                      <TableRow>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("12em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Fund</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"420"}}>
                            Value
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}


                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"420"}}>
                          Estate/Residue
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Spouse</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Dependents</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Trust</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Charity</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Other</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}> </Typography>
                        </TableCell>


                      </TableRow>

                    </TableHead>
                    <TableBody>

                    {
                        this.props.state.needs.cashBequests.map((e, i) => 
                        {
                          
                          if(e.category == "cashBequest" || e.category == "cashBequestCharity")
                          return (
                              <TableRow key={i}>

                              <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {this.props.state.needs.cashBequests[i].incomeStream}
                                      </Typography>
                                </TableCell>

                                <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        R {grandSeperator(this.props.state.needs.cashBequests[i].mounthlyAmount)}
                                      </Typography>
                                </TableCell>

                                {/*<CustomField
                                  name={'needs.cashBequests.estate' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeEstate(f,h)
                                    }}
                                  />*/}
                                  <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {this.props.state.needs.cashBequests[i].estateInherit}%
                                      </Typography>
                                  </TableCell>

                                 <CustomField
                                  name={'needs.cashBequests.spouse' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeSpouse(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'needs.cashBequests.dependents' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeDependents(f,h)
                                    }}
                                />

                                <CustomField
                                  name={'needs.cashBequests.trust' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeTrust(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'needs.cashBequests.charity' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeCharity(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'needs.cashBequests.other' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeOther(f,h)
                                    }}
                                />

                              <TableCell className="cellPaddingSmall">
                                 
                                </TableCell>

                                 

                                
                              </TableRow>
                          )
                        })
                     }

                      <TableRow>



                      <TableCell className="cellPaddingSmall"
                      style={colwidth("12em")}>
                          
                            
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                
                               </Typography>
                            
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getBequestsTotalValue()}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "estateInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "spouseInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "dependentsInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "trustInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "charityInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.bequests == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("needs.cashBequests", "otherInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                       
                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                
                               </Typography>
                            
                         
                        </TableCell>



                      </TableRow>

                    </TableBody>
                  </Table>

                </Grid>

              </ExpansionPanelDetails>

            </ExpansionPanel>


            <ExpansionPanel defaultExpanded={0 === 1} key={1} onClick={(event) => this.retirementExpand(event)} >
              <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
                <Table>
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("12em")}
                      //colSpan={6}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        Retirement Funds
                      </Typography>
                    </TableCell>
                    <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getRetirementTotalValue()}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "estateInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "spouseInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "dependentsInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "trustInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "charityInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == false &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "otherInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                       


                        <TableCell className="cellPaddingSmall"
                          style={colwidth("6em")}>
                         
                        </TableCell>


                  </TableRow>
                 
                </Table>

              </ExpansionPanelSummary>
              <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                      <TableRow>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("12em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Fund</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"420"}}>
                            Value
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}


                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontWeight:"420"}}>
                          Estate/Residue
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Spouse</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Dependents</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Trust</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Charity</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}>Other</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" , fontWeight:"420"}}> </Typography>
                        </TableCell>


                      </TableRow>

                    </TableHead>
                    <TableBody>

                    {
                        this.props.state.retirement.map((e, i) => 
                        {
                         
                          return (
                              <TableRow key={i}>

                              <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {this.props.state.retirement[i].description}
                                      </Typography>
                                </TableCell>

                                <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        R {grandSeperator(this.props.state.retirement[i].value)}
                                      </Typography>
                                </TableCell>

                                {/*<CustomField
                                  name={'retirement.estate' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeEstate(f,h)
                                    }}
                                  />*/}
                                  <TableCell className="cellPaddingSmall">
                                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                        {this.props.state.retirement[i].estateInherit}%
                                      </Typography>
                                  </TableCell>

                                 <CustomField
                                  name={'retirement.spouse' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeSpouse(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'retirement.dependents' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeDependents(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'retirement.trust' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeTrust(f,h)
                                    }}
                                />

                                <CustomField
                                  name={'retirement.charity' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeCharity(f,h)
                                    }}
                                />

                                 <CustomField
                                  name={'retirement.other' + i}
                                  suffix="%"
                                  component={NumberInput}
                                  checkValidation={this.props.checkValidation}
                                  label={'%*'}
                                  isrequired={true}
                                  validate={[required, this.mustBeFullPercentage]}
                                  onChange = {(e, f, g, h) => 
                                    {
                                      this.changeOther(f,h)
                                    }}
                                />

                              <TableCell className="cellPaddingSmall">
                                 
                                </TableCell>

                                 

                                
                              </TableRow>
                          )
                        })
                     }

                      <TableRow>



                      <TableCell className="cellPaddingSmall"
                      style={colwidth("12em")}>
                          
                            
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                
                               </Typography>
                            
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getRetirementTotalValue()}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "estateInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "spouseInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "dependentsInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "trustInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "charityInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            {this.props.state.deathDistribution.expanded.retirement == true &&
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' , fontStyle:"oblique", fontWeight:"420"}}>
                                R {this.getInheretValue("retirement", "otherInherit")}
                               </Typography>
                            }
                         
                        </TableCell>

                       
                        <TableCell className="cellPaddingSmall"
                      style={colwidth("6em")}>
                          
                            
                              <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                                
                               </Typography>
                            
                         
                        </TableCell>



                      </TableRow>

                    </TableBody>
                  </Table>

                </Grid>

              </ExpansionPanelDetails>

            </ExpansionPanel>


          </CardContent>
        </Card>
      </div>
    );
  }
}

export default OtherIncome;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/OtherIncome.jsx